import React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import { classNames } from '../../utils/classNames';

interface IInput {
    label?: string;
    register?: UseFormRegisterReturn;
    placeholder?: string;
    error?: string;
    type?: string;
    containerStyle?: string;
    inputValue?: string | number;
    showValue?: boolean;
    onChangeInput?: (value: string | null | undefined, type: string) => void;
    inputUniqueName?: string;
    inputStyle?: string;
    hideInputSpace?: boolean;
    icon?: string;
    disabled?: boolean;
}

const Input = ({
    register,
    placeholder,
    type,
    error,
    label,
    containerStyle,
    inputValue,
    showValue,
    onChangeInput,
    inputUniqueName,
    inputStyle,
    hideInputSpace,
    icon,
    disabled
}: IInput) => {
    return (
        <div className={containerStyle || 'mb-3'}>
            {!!label && <label className='block text-primary-light font-normal text-base mb-1'>{label}</label>}
            {icon && <img src={icon} className={'absolute w-[18px] object-contain left-2 top-[27%]'} />}
            <input
                {...register}
                disabled={disabled || false}
                type={type}
                {...showValue && ({
                    value: inputValue || '',
                    onChange: (e) => onChangeInput?.(e?.target?.value, inputUniqueName || '')
                })}
                placeholder={placeholder}
                autoComplete='off'
                className={classNames('border border-borderColor rounded w-full px-3 py-2', error ? 'border-red-500' : '', icon ? 'pl-8' : '', inputStyle || '')}
            />
            {error ? <span className='block text-xs text-red-500'>{error}</span> : !hideInputSpace && <span className='block h-2 mt-2' />}
        </div>

    )
}

export default Input;